<div class="right-panel">
  <div class="panel-header">
    <p class="panel-title">Modify Activation Agreement</p>
  </div>
  <div class="panel-container">
    <form name="createAA"
          class="createNS"
          #validate="ngForm">

      <div class="createNS-row">
        <label class="widget-create-title">NS
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input class="widget-create-content"
               value="{{nsName}}, {{netIds}}"
               disabled/>
      </div>

      <div class="createNS-row">
        <label class="widget-create-title">JS
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input class="widget-create-content"
               value="{{jsName}}, {{joinEuis}}"
               disabled/>
      </div>

      <div class="createNS-row">
        <label class="widget-create-title">Subscriber ID
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <textarea id="subscriber_id"
                  rows="2" class="widget-create-content form-control"
                  [(ngModel)]="subscriberId"
                  name="subscriber_id"
                  #inputSubscriberId
                  autocomplete="off"
                  maxlength="80" size="80"></textarea>
      </div>

      <div class="btn-area">
        <button (click)="backClicked()"
                class="custom-btn">Cancel
        </button>
        <button type="submit"
                class="custom-btn create-btn form-control"
                (click)="save()">Save
        </button>
      </div>
    </form>
  </div>
</div>
